// extracted by mini-css-extract-plugin
export default {"courseContainer":"SingleCourse_courseContainer__qid9a","title":"SingleCourse_title__nkVFQ","subtitle":"SingleCourse_subtitle__PptAl","backToBtn":"SingleCourse_backToBtn__KZuV8"};